module.exports = __webpack_public_path__ + "img/enBannerD.89e9381b.png";